import { z } from 'zod';

export const Uuid = z.uuid();
export const IdParams = z.object({ id: z.uuid() });

/** Trims; empty string → null. Use for optional text fields coming from forms. */
export const NullableText = (max = 2000) =>
  z
    .string()
    .max(max)
    .transform((v) => v.trim())
    .transform((v) => (v === '' ? null : v))
    .nullable();

export const RequiredText = (max = 500) => z.string().trim().min(1, 'Required').max(max);

export const Pagination = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(50),
});

export type Paginated<T> = { items: T[]; total: number; page: number; pageSize: number };

/** Standard error envelope returned by the API. */
export type ApiErrorBody = { error: { code: string; message: string; details?: unknown } };

/** ISO date-time string as sent over the wire. */
export type IsoDateTime = string;
